import * as React from 'react';
import { SearchFiltersTranslation } from '../constants';
import { SearchFilters } from '../filters/search-filters';
import { FilterConfigurationProps } from '../filters/types';
import { QueryConfigurationProps } from './types';
import { SearchLayout } from './search-layout';

interface SearchContainerProps {
  topToolbar: JSX.Element;
  rightToolbar: JSX.Element;
  hideDrawer: boolean;
  hideSearch: boolean;
  wideScreen: boolean;

  locale: string;
  translation: SearchFiltersTranslation;

  querySettings: QueryConfigurationProps;
  filterSettings: FilterConfigurationProps;

  updateSearchModel: () => void;
  debouncedUpdateSearchModel: () => void;
  children?: React.ReactNode;
}

const emptyFilter = { filters: [], values: {}, menuValues: {} };

export class SearchContainer extends React.PureComponent<SearchContainerProps> {

  public componentDidMount() {
    this.props.updateSearchModel();
  }

  public componentDidUpdate(prevProps: SearchContainerProps) {

    const { querySettings: { query = '', values: queryValues = undefined } = {}, debouncedUpdateSearchModel } = this.props;
    const { values, menuValues } = this.props.filterSettings || emptyFilter;
    const { querySettings: { query: prevQuery = '', values: prevQueryValues = undefined } = {} } = prevProps;
    const { values: prevFilterValues, menuValues: prevFilterMenuValues } = prevProps.filterSettings || emptyFilter;

    if (prevQuery !== query
      || prevQueryValues !== queryValues
      || prevFilterValues !== values
      || prevFilterMenuValues !== menuValues) {
      debouncedUpdateSearchModel();
    }
  }

  public render() {

    const { children, rightToolbar, locale, translation, topToolbar, hideDrawer, hideSearch, wideScreen,
      querySettings, filterSettings, updateSearchModel } = this.props;
    return <>
      <SearchLayout
        topToolbar={topToolbar}
        rightToolbar={rightToolbar}
        hideSearch={hideSearch}
        querySettings={querySettings}
        translation={translation}
        onSearch={updateSearchModel} />
      <SearchFilters
        hideDrawer={hideDrawer}
        wideScreen={wideScreen}
        filterSettings={filterSettings}
        translation={translation}
        locale={locale}>
        {children}
      </SearchFilters>
    </>;
  }
}
